/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePracticeDto
 */
export interface UpdatePracticeDto {
    /**
     * Practice name
     * @type {string}
     * @memberof UpdatePracticeDto
     */
    name?: string;
    /**
     * Practice logo URL from Firebase Storage
     * @type {string}
     * @memberof UpdatePracticeDto
     */
    logoUrl?: string;
    /**
     * Practice phone number
     * @type {string}
     * @memberof UpdatePracticeDto
     */
    phone?: string;
    /**
     * Phone dial code (e.g. +1)
     * @type {string}
     * @memberof UpdatePracticeDto
     */
    phoneCountryCode?: string;
    /**
     * Phone country ISO alpha-2 code (e.g. US)
     * @type {string}
     * @memberof UpdatePracticeDto
     */
    phoneCountryIso2?: string;
}

/**
 * Check if a given object implements the UpdatePracticeDto interface.
 */
export function instanceOfUpdatePracticeDto(value: object): value is UpdatePracticeDto {
    return true;
}

export function UpdatePracticeDtoFromJSON(json: any): UpdatePracticeDto {
    return UpdatePracticeDtoFromJSONTyped(json, false);
}

export function UpdatePracticeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePracticeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'phoneCountryCode': json['phoneCountryCode'] == null ? undefined : json['phoneCountryCode'],
        'phoneCountryIso2': json['phoneCountryIso2'] == null ? undefined : json['phoneCountryIso2'],
    };
}

export function UpdatePracticeDtoToJSON(json: any): UpdatePracticeDto {
    return UpdatePracticeDtoToJSONTyped(json, false);
}

export function UpdatePracticeDtoToJSONTyped(value?: UpdatePracticeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'logoUrl': value['logoUrl'],
        'phone': value['phone'],
        'phoneCountryCode': value['phoneCountryCode'],
        'phoneCountryIso2': value['phoneCountryIso2'],
    };
}

